import { Box, Tooltip } from "@mui/material"
import "./styles.scss"
import { useTranslation } from "react-i18next"
import { useMemo } from "react"
import { Chip, splitArray, Typography } from "@cakemail-org/ui-components-v2"
import { ETemplatesFilters, templateTagsFilterOptions } from "../../../data/tags"

export function TagsTableCol({ tags = [] }: { tags?: string[] }) {
    const { t, i18n } = useTranslation()
    const transformedTags = useMemo<string[]>(() => {
        return tags?.map((tag) => {
            let res = ""
            if (tag === "free") {
                res = t("general-free-DD")
            } else if (tag === "paid") {
                res = t("general-paid-DD")
            } else {
                if (tag.startsWith("sys_lang_")) {
                    let resTag = tag.replace("sys_lang_", "").replace("_", "-").split("-")
                    let finalTag = resTag[0]
                    if (resTag.length > 1) {
                        resTag[1] = resTag[1].toUpperCase()
                        finalTag = resTag.join("-")
                    }
                    res = t("general-languages_" + finalTag)
                } else {
                    for (const filterKey of Object.values(ETemplatesFilters)) {
                        let found = false
                        if (filterKey !== ETemplatesFilters.noFilters) {
                            for (const tagFilter of templateTagsFilterOptions()[filterKey]) {
                                if (tag.includes(tagFilter.value)) {
                                    res = tagFilter.text
                                    found = true
                                    break
                                }
                            }
                        }
                        if (found) break
                    }

                    if (!res) {
                        res = tag
                    }
                }
            }

            return res
        }) || []
    }, [tags])

    const { firstArray, secondArray } = splitArray<string>(transformedTags, 8)

    return <Box className="tagsTableCol">
        {firstArray?.map((t, index) => {
            return <Chip key={"chip-" + index} variant="outlined" color="body1" label={t} />
        })}
        {secondArray?.length > 0 &&
            <Tooltip title={secondArray?.join(", ")}>
                <Box className="seeMore"><Typography variant="linkL">{t("general-x-more", { count: 2 })}</Typography></Box>
            </Tooltip>
        }
    </Box>

}